import { LANGAUGES } from 'lib/context';
import * as React from 'react';
import { useMemo } from 'react';
export type Option = {
  value: string | number;
  label: React.ReactNode | string;
};
type Namespace = 'language';

type Overrides = Partial<Record<Namespace, Option[]>>;

const SpainFlag = <span>🇪🇸</span>;
const UKFlag = <span>🇬🇧</span>;
const FranceFlag = <span>🇫🇷</span>;

export function useGetStaticDropdownOptions(overrides?: Overrides) {
  const registry = useMemo<Record<Namespace, Option[]>>(() => {
    const language: Option[] = [
      { value: LANGAUGES.ES, label: <>{SpainFlag} ES</> },
      { value: LANGAUGES.EN, label: <>{UKFlag} EN</> },
      { value: LANGAUGES.FR, label: <>{FranceFlag} FR</> },
    ];

    return {
      language: overrides?.language ?? language,
    };
  }, [overrides]);

  // maybe for later, write pick, map, get methods for more options
  return {
    languageOptions: registry.language,
  };
}
